import React from 'react';
export const FeaturesSection = () => {
  return <section className="py-10 md:py-16 px-6 md:px-10 bg-navy text-cream" data-id="element-96">
      <div className="max-w-4xl mx-auto" data-id="element-97">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 md:mb-12 text-center" data-id="element-98">
          Qué incluye ¿DÓNDE SE VA MI DINERO?
        </h2>
        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-99">
          <div className="bg-navy/40 p-6 rounded-lg border-l-4 border-gold" data-id="element-100">
            <h3 className="text-xl font-bold text-gold mb-2" data-id="element-101">
              Método de 10 Minutos™
            </h3>
            <p className="serif-text" data-id="element-102">
              Claridad financiera en solo 10 minutos al mes.
            </p>
          </div>
          <div className="bg-navy/40 p-6 rounded-lg border-l-4 border-gold" data-id="element-103">
            <h3 className="text-xl font-bold text-gold mb-2" data-id="element-104">
              Mapa de Fugas™
            </h3>
            <p className="serif-text" data-id="element-105">
              Identifica exactamente dónde se evapora tu dinero.
            </p>
          </div>
          <div className="bg-navy/40 p-6 rounded-lg border-l-4 border-gold" data-id="element-106">
            <h3 className="text-xl font-bold text-gold mb-2" data-id="element-107">
              Estrategia 20–40% Extra™
            </h3>
            <p className="serif-text" data-id="element-108">
              Haz que tu quincena rinda más sin trabajar más.
            </p>
          </div>
          <div className="bg-navy/40 p-6 rounded-lg border-l-4 border-gold" data-id="element-109">
            <h3 className="text-xl font-bold text-gold mb-2" data-id="element-110">
              Sistema "Ayudo Sin Quedarme Vacía"™
            </h3>
            <p className="serif-text" data-id="element-111">
              Apoya a tu familia sin sacrificar tu estabilidad.
            </p>
          </div>
          <div className="bg-navy/40 p-6 rounded-lg border-l-4 border-gold" data-id="element-112">
            <h3 className="text-xl font-bold text-gold mb-2" data-id="element-113">
              Ritual de la Quincena™
            </h3>
            <p className="serif-text" data-id="element-114">
              Transforma el día de pago en un momento de poder.
            </p>
          </div>
          <div className="bg-navy/40 p-6 rounded-lg border-l-4 border-gold" data-id="element-115">
            <h3 className="text-xl font-bold text-gold mb-2" data-id="element-116">
              Plan $100–$200 Extra al Mes™
            </h3>
            <p className="serif-text" data-id="element-117">
              Estrategias simples para retener más de tu dinero.
            </p>
          </div>
          <div className="bg-navy/40 p-6 rounded-lg border-l-4 border-gold" data-id="element-118">
            <h3 className="text-xl font-bold text-gold mb-2" data-id="element-119">
              Método Antiansiedad™
            </h3>
            <p className="serif-text" data-id="element-120">
              Elimina el estrés financiero con claridad y control.
            </p>
          </div>
          <div className="bg-navy/40 p-6 rounded-lg border-l-4 border-gold" data-id="element-121">
            <h3 className="text-xl font-bold text-gold mb-2" data-id="element-122">
              Método "Gustito Sin Culpa"™
            </h3>
            <p className="serif-text" data-id="element-123">
              Disfruta pequeños placeres sin remordimiento.
            </p>
          </div>
        </div>
        <p className="text-center text-xl" data-id="element-124">
          Todo en un formato visual, simple y fácil de seguir.
        </p>
      </div>
    </section>;
};